import React, { useState } from "react";
import Cart from "./Cart";
export default function CartButton(props) {
  const [modalOpened, setModalOpened] = useState(false);
  const { cart } = props.context;
  return (
    <>
      <div
        onClick={() => setModalOpened(!modalOpened)}
        className="btn px-2 btn-light  mr-2"
      >
        <i className="fa fa-shopping-cart"></i>
        {cart.cartCount > 0 && (
          <span className="label label-primary ml-2">{cart.cartCount}</span>
        )}
      </div>
      {modalOpened && <Cart onHide={() => setModalOpened(false)} {...props} />}
    </>
  );
}
